import { render } from "./PodSecurityAdmission.vue?vue&type=template&id=fb54238e&ts=true"
import script from "./PodSecurityAdmission.vue?vue&type=script&lang=ts"
export * from "./PodSecurityAdmission.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__